import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function OnboardingChecklist({ user, patients, vitals, documents }) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const isDismissed = localStorage.getItem('onboarding_dismissed') === 'true';
    setDismissed(isDismissed);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('onboarding_dismissed', 'true');
    setDismissed(true);
  };

  if (dismissed) {
    return null;
  }

  const steps = [
    {
      id: 'profile',
      title: 'Complete your profile',
      description: 'Add your date of birth, gender and phone number',
      done: !!(user?.phone && user?.date_of_birth && user?.gender),
      action: 'Go to Profile',
      link: '/profile'
    },
    {
      id: 'vital',
      title: 'Record your first vital',
      description: 'Track your blood pressure, blood sugar or weight',
      done: vitals && vitals.length > 0,
      action: 'Add Vital',
      link: patients?.[0] ? `/patients/${patients[0].patient_id}/vitals/new` : '/dashboard'
    },
    {
      id: 'document',
      title: 'Upload a health document',
      description: 'Upload a lab report, prescription or any medical document',
      done: documents && documents.length > 0,
      action: 'Upload Document',
      link: patients?.[0] ? `/patients/${patients[0].patient_id}/documents/new` : '/dashboard'
    }
  ];

  const completedCount = steps.filter(s => s.done).length;
  const progressPercent = Math.round((completedCount / steps.length) * 100);

  if (completedCount === steps.length) {
    return null;
  }

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      borderLeft: '4px solid #667eea',
      marginBottom: '24px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px'
      }}>
        <h3 style={{ color: '#2d3748', margin: 0, fontSize: '1.2rem' }}>
          🚀 Getting Started
        </h3>
        <span style={{ color: '#718096', fontSize: '0.9rem' }}>
          {completedCount} of {steps.length} completed
        </span>
      </div>

      <div style={{
        height: '8px',
        backgroundColor: '#e2e8f0',
        borderRadius: '4px',
        marginBottom: '20px',
        overflow: 'hidden'
      }}>
        <div style={{
          height: '100%',
          width: `${progressPercent}%`,
          backgroundColor: '#48bb78',
          transition: 'width 0.3s ease'
        }} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {steps.map(step => (
          <div key={step.id} style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px'
          }}>
            <span style={{
              fontSize: '1.2rem',
              flexShrink: 0,
              marginTop: '2px'
            }}>
              {step.done ? '✅' : '⭕'}
            </span>
            <div style={{ flex: 1 }}>
              <div style={{
                color: '#2d3748',
                fontWeight: step.done ? 500 : 600,
                fontSize: '0.95rem',
                textDecoration: step.done ? 'line-through' : 'none',
                marginBottom: '2px'
              }}>
                {step.title}
              </div>
              <div style={{
                color: '#718096',
                fontSize: '0.85rem',
                marginBottom: step.done ? 0 : '8px'
              }}>
                {step.description}
              </div>
              {!step.done && (
                <Link
                  to={step.link}
                  style={{
                    display: 'inline-block',
                    padding: '6px 12px',
                    backgroundColor: '#667eea',
                    color: 'white',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontSize: '0.85rem',
                    fontWeight: '500'
                  }}
                >
                  {step.action}
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: '16px',
        paddingTop: '12px',
        borderTop: '1px solid #e2e8f0',
        textAlign: 'right'
      }}>
        <button
          onClick={handleDismiss}
          style={{
            background: 'none',
            border: 'none',
            color: '#a0aec0',
            fontSize: '0.85rem',
            cursor: 'pointer',
            padding: '4px 8px'
          }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}

export default OnboardingChecklist;
